import { Channel } from '@/Enums/Channel.enum';
import ForecasterDateTab from '@/Enums/Forecaster/DateTab.enum';
import type { IImpressionCalculation } from '@/Interfaces/Forecaster';
import { EstimationTabLabels } from '@/constants/Forecaster/EstimationTabs';
import type { FC } from 'react';
import BasicTab from './BasicTab';
import DoohTab from './DoohTab';

interface IComponentProps {
  data: IImpressionCalculation | null;
  currentChannel?: Channel;
}

interface ITab {
  id: ForecasterDateTab;
  name: string;
  Component: FC<IComponentProps>;
}

const tabs = [ForecasterDateTab.Week, ForecasterDateTab.Day, ForecasterDateTab.Month, ForecasterDateTab.Custom];

export const getCommonTabs = (showReach: boolean = true): ITab[] =>
  tabs.map(tab => {
    const name = EstimationTabLabels[tab];
    return {
      id: tab,
      name,
      Component: ({ data, currentChannel }) => (
        <BasicTab
          showReach={showReach}
          showDatePicker={tab === ForecasterDateTab.Custom}
          tabName={`${name} ${currentChannel}`}
          currentChannel={currentChannel}
          data={data}
        />
      ),
    };
  });

const DOOH_TABS: ITab[] = tabs.map(tab => {
  const name = EstimationTabLabels[tab];
  return {
    id: tab,
    name,
    Component: ({ data, currentChannel }) => (
      <DoohTab
        showDatePicker={tab === ForecasterDateTab.Custom}
        data={data}
        label={name}
        currentChannel={currentChannel}
      />
    ),
  };
});

export const getChannelTabs = (showReach: boolean): Partial<Record<Channel, ITab[]>> => ({
  [Channel.CTV]: getCommonTabs(showReach),
  [Channel.Display]: getCommonTabs(showReach),
  [Channel.OLV]: getCommonTabs(showReach),
  [Channel.Audio]: getCommonTabs(showReach),
  [Channel.Dooh]: DOOH_TABS,
  [Channel.Google]: getCommonTabs(false),
  [Channel.GamVideo]: getCommonTabs(false),
  [Channel.GamDisplay]: getCommonTabs(false),
});
